export default function Post(props : {title:string, imageurl:string}){
    console.log("post")
    return(
        <div>
            {props.title}
            <img src = {props.imageurl} className="w-10 h-10"></img>
        </div>
    )
}